import React from "react";
import "./Tabs.css";

const Settings = () => {
  return (
    <div className="tab-content">
      <h2>설정</h2>
      <p>시스템 설정과 개인 설정이 여기에 들어갑니다.</p>

      <div className="settings-section">
        <h3>알림 설정</h3>
        <div className="settings-form">
          <div className="setting-item">
            <label>이메일 알림</label>
            <input type="checkbox" defaultChecked />
          </div>
          <div className="setting-item">
            <label>푸시 알림</label>
            <input type="checkbox" defaultChecked />
          </div>
          <div className="setting-item">
            <label>SMS 알림</label>
            <input type="checkbox" />
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>테마 설정</h3>
        <div className="settings-form">
          <div className="setting-item">
            <label>테마</label>
            <select defaultValue="light">
              <option value="light">라이트</option>
              <option value="dark">다크</option>
              <option value="auto">시스템 설정 따름</option>
            </select>
          </div>
          <div className="setting-item">
            <label>언어</label>
            <select defaultValue="ko">
              <option value="ko">한국어</option>
              <option value="en">English</option>
              <option value="ja">日本語</option>
            </select>
          </div>
        </div>
      </div>

      <div className="settings-section">
        <h3>보안 설정</h3>
        <div className="settings-form">
          <div className="setting-item">
            <label>2단계 인증</label>
            <input type="checkbox" />
          </div>
          <div className="setting-item">
            <label>세션 타임아웃</label>
            <select defaultValue="30">
              <option value="15">15분</option>
              <option value="30">30분</option>
              <option value="60">1시간</option>
              <option value="120">2시간</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
